import React from "react"

import styles from "./list-reviews.module.css"

export default function ListReviews({ children }) {
  return <div className={styles.listReviews}>{children}</div>
}
